import React from 'react';

const Footer = () => {
  return (
      <footer className="flex justify-center bg-gray-200 p-4">
          <p></p>
      </footer>
  );
};

export default Footer;
